// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"7f9d1f2a","234":"9ffd0ecc","608":"2ac60421"}[chunkId] + ".chunk.js";
};